import React, {useState} from "react";
import {Box, Typography, List, ListItem, ListItemText, Grid} from "@mui/material";
import {CustomTabs, CustomTab} from "../common/custom-buttonTab";
import CertificateIcon from "../../assets/icons/certificate.png";
import AnomalyHistoryLogDetailViewDialog from "./dialog/anomaly-history-log-detail-view.dialog";
import moment from "moment";

const AnomalyHistoryLogComponent = (props) => {

    const {breakpoints, anomalyHistoryLogList} = props;

    const [value, setValue] = useState(0);
    const [openHistoryLog, setOpenHistoryLog] = useState(false);
    const [anomalyId, setAnomalyId] = useState(null);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    }

    const handleHistoryLogClick = (e, anomalyItem) => {
        setAnomalyId(anomalyItem?.anomaly_id);
        setOpenHistoryLog(true);
    }


    return (
        <Box sx={{border: "1px solid #7A78F74F", borderRadius: "4px", padding: "20px"}}>
            <CustomTabs value={value} onChange={handleChange} aria-label="custom tabs example">
                <CustomTab label="History" sx={{borderTopRightRadius: "0px", borderBottomRightRadius: "0px"}} />
                <CustomTab label="Security Logs" sx={{borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px"}} />
            </CustomTabs>

            {(value == 0) ?
                <Box sx={{maxHeight: 350, overflowY: "auto", 
                    "&::-webkit-scrollbar": {
                        width: "8px"
                    },
                    "&::-webkit-scrollbar-track": {
                        background: "rgba(217, 217, 217, 0.5)"
                    },
                    "&::-webkit-scrollbar-thumb": {
                        background: "#7a78f7a6",
                        borderRadius: "4px"
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                        background: "#7A78F7"
                    }}}
                >
                    <List sx={{cursor: "pointer"}}>
                        {anomalyHistoryLogList?.map((anomalyItem, i) => (
                            <div onClick={(e) => handleHistoryLogClick(e, anomalyItem)}> 
                                <ListItem key={i} divider sx={{borderBottom: "1px solid #7A78F74F"}}>
                                    <Grid container>
                                        <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
                                            <ListItemText
                                                primary={
                                                    <Typography sx={{color: "#58565f", fontSize: 14, fontWeight: "bold"}}>
                                                        {anomalyItem?.ovi}
                                                    </Typography>
                                                }
                                                secondary={
                                                    <Typography sx={{color: "#58565f", fontSize: 14}}>
                                                        Location: {anomalyItem?.verificationLogs?.location}
                                                    </Typography>
                                                }
                                            />
                                        </Grid>

                                        <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                            <ListItemText sx={{display: "flex"}}
                                                primary={""}
                                                secondary={
                                                    <Box sx={{display: "flex"}}>
                                                        <Typography sx={{color: "#58565f", fontSize: 14}}>
                                                            {moment(anomalyItem?.date).format('YYYY-MMDD')}
                                                        </Typography>
                                
                                                        <img alt="document-icon" src={CertificateIcon} style={{height: 30, width: 30, cursor: "pointer", marginTop: "-3px", marginLeft: "24px"}} />
                                                    </Box>
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                </ListItem>
                            </div>
                        ))}
                    </List>
                </Box>
            :
                
                null
            }

            {openHistoryLog &&
                <AnomalyHistoryLogDetailViewDialog openHistoryLog={openHistoryLog}
                    setOpenHistoryLog={setOpenHistoryLog} breakpoints={breakpoints}
                    anomalyId={anomalyId}
                />
            }
        </Box>
    )
}

export default AnomalyHistoryLogComponent